import React, { Component, useEffect, useRef, useState } from "react";
import {
  Layout,
  Typography,
} from "antd";


import HeaderBar from "./HeaderBar";
import Footerbar from "../sections/Footerbar";


const { Title, Paragraph  } = Typography;
const { Header, Footer, Content } = Layout;

const contentStyle = {
    textAlign: 'center',
    color: "#00803e",
    backgroundColor: "white",
    borderRadius: "8px",
    border: 'none',
    marginTop: 18,
    padding: '1rem',
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px'
  };

export default function AboutUs() {

  
  return (
    <>
      <div className="layout-default ant-layout layout-sign-up">
        <HeaderBar />

        <div className="landing-header absolute w-full z-0" style={{
          position: 'absolute',
          width: '100%',
          zIndex: 0
        }}>
          <div className="content">
            <Title style={{color: 'black'}}>About Us</Title>
          </div>
        </div>

        <div className="p-0 my-16 mx-24" style={{
          zIndex: 20,
          marginTop: '11rem'
        }}>
          
          <div style={contentStyle}>
            {/* Center-aligned Heading */}
            <Title level={2} className="text-green-700 text-center !mb-10 !mt-10">
              Welcome to Sawari Pakistan Limited
            </Title>

            {/* Left-aligned Paragraphs */}
            <Paragraph className="text-gray-700 text-left text-base md:text-lg leading-relaxed">
            Welcome to Sawari Pakistan Limited, a leading transportation and tourism service provider operating in collaboration with Sawari Airport Transfers (SMC-Private) Limited. With a strong presence in both the United Kingdom and Pakistan, we pride ourselves on delivering outstanding airport transfer services, vehicle rentals, and exceptional tourism packages all across Pakistan.
            </Paragraph>
            <Paragraph className="text-gray-700 text-left text-base md:text-lg leading-relaxed">
                Our commitment to excellence and customer satisfaction has led us to become a trusted choice for locals and international travellers alike. With a wealth of experience in the industry, we understand the importance of seamless and reliable transportation solutions, as well as creating unforgettable experiences for those exploring the beauty of Pakistan.
            </Paragraph>
            <Paragraph className="text-gray-700 text-left text-base md:text-lg leading-relaxed">
                At Sawari Pakistan Limited, we strive to exceed expectations through our comprehensive range of services. Whether you need a convenient airport transfer, reliable vehicle rental for your travel needs, or a tailored tourism package to explore the hidden gems of Pakistan, we have you covered.
            </Paragraph>
            <Paragraph className="text-gray-700 text-left text-base md:text-lg leading-relaxed">
                As technology-driven professionals, we have developed a dynamic website and mobile applications that allow you to access instant quotations. With just a few simple details, our user provide you with accurate pricing information.
            </Paragraph>
            <Paragraph className="text-gray-700 text-left text-base md:text-lg leading-relaxed">
                As the sole owner of these companies, my name is Mr. Mohammad Asif. With a deep passion for providing exceptional services, I have devoted my time and expertise to ensuring that both Sawari Pakistan Limited and Sawari Airport Transfers (SMC-Private) Limited are synonymous with reliability, professionalism, and customer satisfaction.
            </Paragraph>
            <Paragraph className="text-gray-700 text-left text-base md:text-lg leading-relaxed">
                Our team of dedicated and experienced professionals are always available to assist you, whether you have queries about our services or need guidance in planning your perfect travel itinerary. We take great pride in offering personalized support and ensuring that every customer's individual needs are met with care and attention to detail.
            </Paragraph>
            <Paragraph className="text-gray-700 text-left text-base md:text-lg leading-relaxed">
                We believe in promoting the beauty, cultural richness, and diversity of Pakistan. Our commitment to sustainable tourism practices ensures that our operations contribute positively to the local communities we serve. By choosing our services, you are not only experiencing the best that Pakistan supporting responsible and ethical travel.
            </Paragraph>
            <Paragraph className="text-gray-700 text-left text-base md:text-lg leading-relaxed">
                Thank you for choosing Sawari Pakistan Limited and Sawari Airport Transfers (SMC-Private) Limited. We look forward to being a part of your memorable journey, creating unforgettable experiences, and being your trusted partner in transportation and tourism services throughout Pakistan!
            </Paragraph>
          </div>
          <div style={{ marginTop: 24 }} className="flex justify-end">
          </div>
        </div>
        <Footerbar bgColorClass="bg-neutral-light" />
      </div>
    </>
  );
}